var hostname = window.location.hostname;
var isProd = hostname === "sakura.karaqgames.com";
var disable = isProd ? false : true;
window.__bl = {
    config: {
        pid: "egrrccpv71@789216fa7e2c67d",
        appType: "web",
        imgUrl: "https://arms-retcode.aliyuncs.com/r.png?",
        sendResource: true,
        enableLinkTrace: true,
        behavior: true,
        disabled: disable,
        environment: isProd ? "prod" : "local",
        page: window.pageName,
    },
};